var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#09090b",
    cx: 32,
    width: 64,
    height: 64,
    cy: 32,
    r: 32
  })), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    style: {
      color: "#FFFFFF",
      lineHeight: 1,
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
    },
    alignmentBaseline: "middle",
    textAnchor: "middle",
    fontSize: 28,
    fontWeight: 400,
    dy: ".1em",
    dominantBaseline: "middle",
    fill: "#FFFFFF"
  }, "DU"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.a64cfa23acfff2388a4b98ec7563f0af.svg";
export { ForwardRef as ReactComponent };